.bold {
	font-weight: bold !important;
}
